import { render, staticRenderFns } from "./Equivalencia.vue?vue&type=template&id=4b15c80b"
import script from "./Equivalencia.vue?vue&type=script&lang=js"
export * from "./Equivalencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports